import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeAsnIncomeActionAsync } from '../redux/actions/typeAsnIncomeActions'

export const useTypeAsnIncome = () => {
  const { typeAsnIncomeState } = useSelector(
    (state: RootState) => state.typeAsnIncome
  )
  const dispatch = useDispatch()

  const getTypeAsnIncome = () => {
    dispatch(getTypeAsnIncomeActionAsync())
  }

  return { typeAsnIncomeState, getTypeAsnIncome }
}
